import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';

// Import reducers
import reducer from './reducers';

// Import api
import { api } from 'store/api';

// ATTENTION: use this functionality wisely, remember to cleanup listeners
export const listenerMiddleware = createListenerMiddleware();

const store = configureStore({
	reducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).prepend(listenerMiddleware.middleware).concat(api.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
